import { faker } from '@faker-js/faker'
import { http, HttpResponse } from 'msw'

import type { GetAdditionalContactsResponse } from '@/api/my-business/agency-chains/get-additional-contacts'

interface MockGetAgencyChainAdditionalContactsPathParams {
  agencyChainAlphaId: string
}

export const mockGetAgencyChainAdditionalContacts =
  http.get<MockGetAgencyChainAdditionalContactsPathParams>(
    '/my-business/api/agency/v1/agency-chains/:agencyChainAlphaId/contacts/additional-contacts',
    () => {
      const response: {
        data: GetAdditionalContactsResponse[]
        timestamp: string
      } = {
        timestamp: faker.date.recent().toISOString(),
        data: Array.from({ length: 3 }).map(() => ({
          address: {
            address: faker.location.streetAddress(),
            cityId: faker.number.int({ min: 1000, max: 9999 }),
            cityName: faker.location.city(),
            countryCode: faker.location.countryCode(),
            departmentEnum: 'MAIN',
            description: faker.lorem.sentence(),
            number: faker.number.int({ min: 1, max: 999 }).toString(),
            stateCode: faker.location.state({ abbreviated: true }),
            complement: faker.lorem.sentence(),
            neighborhood: faker.lorem.words({ min: 1, max: 2 }),
            zipCode: faker.location.zipCode(),
          },
          alphaId: faker.string.uuid(),
          departmentCode: 'FINANCIAL',
          email: faker.internet.email(),
          phone: faker.phone.number(),
          name: faker.person.fullName(),
        })),
      }

      return HttpResponse.json(response, { status: 200 })
    },
  )
